import { Button, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRegisterAdmin extends Layout {
	Add: Button;
	Delete: Button;
	Refresh: Button;
	Update: Button;
	pnlButtons: Panel;
	tableRegAdmin: Table;
	txtCount: Textbox;
}
